import React, { useState, useMemo } from 'react';
import { DateRange, Input, PrimaryButton, Sub1Button, Select } from '@components/atoms';
import {
  FilterDateRangeStyle,
  FilterSearchButtonStyle,
  FilterSearchConditionStyle,
} from '@components/organisms/Table/Filters/styles';
import { StyledFilterWrapper, SearchInputStyle, StyledPDFButton, StyledProgress } from './styles';
import moment from 'moment';
import { submitDebounce } from '../../../../utils/lib';

const DEFAULT_STATUS_KEY = [
  { label: 'Result All', value: 'All', selected: true },
  { label: 'Complete', value: 'COMPLETE' },
  { label: 'Fail', value: 'FAILED' },
];

interface Props<T = any> {
  downloadProgress: boolean;
  defaultFromDate: string;
  defaultToDate?: string;
  setSearchConditions: React.Dispatch<React.SetStateAction<T>>;
  onPDFDownload: () => void;
}

const TodosFilter = ({ downloadProgress, setSearchConditions, onPDFDownload }: Props) => {
  const [searchKey, setSearchKey] = useState('All');
  const [searchValue, setSearchValue] = useState('');
  const [scanFilterDateRange, setScanFilterDateRange] = useState([
    {
      key: 'selection',
      startDate: null,
      endDate: null,
    },
  ]);

  const [analysisFilterDateRange, setAnalysisFilterDateRange] = useState([
    {
      key: 'selection',
      startDate: null,
      endDate: null,
    },
  ]);

  const scanDateRange = useMemo(() => {
    const startDate = scanFilterDateRange[0].startDate;
    const endDate = scanFilterDateRange[0].endDate;

    return {
      dateRange: {
        startDate: !startDate ? null : moment(startDate).format('YYYY-MM-DD'),
        endDate: !endDate ? null : moment(endDate).format('YYYY-MM-DD'),
      },
    };
  }, [scanFilterDateRange]);

  const analysisDateRange = useMemo(() => {
    const startDate = analysisFilterDateRange[0].startDate;
    const endDate = analysisFilterDateRange[0].endDate;

    return {
      dateRange: {
        startDate: !startDate ? null : moment(startDate).format('YYYY-MM-DD'),
        endDate: !endDate ? null : moment(endDate).format('YYYY-MM-DD'),
      },
    };
  }, [analysisFilterDateRange]);

  /**
   *
   */
  const doSearch = () => {
    setSearchConditions((prevState: any) => ({
      ...prevState,
      currentPage: 1,
      searchValue,
      scanFromDate: scanDateRange.dateRange.startDate,
      scanToDate: scanDateRange.dateRange.endDate,
      analysisFromDate: analysisDateRange.dateRange.startDate,
      analysisToDate: analysisDateRange.dateRange.endDate,
      resultList: searchKey === 'All' ? [] : [searchKey],
    }));
  };

  return (
    <StyledFilterWrapper>
      <div className="filter-area">
        <Input
          type="text"
          value={searchValue}
          placeholder="Search ID/Name/Register"
          styles={SearchInputStyle}
          onChange={(ev) => setSearchValue(ev.target.value)}
        />
        <DateRange
          border
          defaultValue={scanDateRange}
          dateRangeSet={scanFilterDateRange}
          setDateRangeSet={(value) => {
            setScanFilterDateRange(value);
          }}
          placeholder={'Scan Date'}
          styles={FilterDateRangeStyle}
          hasYearOption={true}
          isTabVisible={false}
        />
        <DateRange
          border
          defaultValue={analysisDateRange}
          dateRangeSet={analysisFilterDateRange}
          setDateRangeSet={(value) => {
            setAnalysisFilterDateRange(value);
          }}
          placeholder={'Analysis Date'}
          styles={FilterDateRangeStyle}
          hasYearOption={true}
          isTabVisible={false}
        />
        <Select
          list={DEFAULT_STATUS_KEY.map((item) => ({
            ...item,
            selected: item.value === searchKey,
          }))}
          onSelected={(e) => setSearchKey(e.value)}
          styles={FilterSearchConditionStyle}
        />
        <Sub1Button styles={FilterSearchButtonStyle} onClick={doSearch}>
          Search
        </Sub1Button>
      </div>
      <div>
        <StyledPDFButton disabled={downloadProgress} onClick={onPDFDownload}>
          {downloadProgress ? <StyledProgress /> : <>PDF</>}
        </StyledPDFButton>
      </div>
    </StyledFilterWrapper>
  );
};

export default TodosFilter;
